import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import CtaButton from 'components/essentials/Cta/CtaButton';
import useScreen from 'hooks/useScreen';
import useIsBrowser from 'hooks/useIsBrowser';
import ProductListingLoadMoreButton from './ProductListingLoadMoreButton';
const ProductListingLoadMoreButtons = () => {
  const $ = _c(14);
  const {
    loadAllProducts,
    loadMoreClickCount,
    loadMoreProducts,
    showLoadMoreButton,
    showLoadMoreButtonSpinner,
    hideShowAllButton: t0
  } = useProductListingPageContext();
  const hideShowAllButton = t0 === undefined ? false : t0;
  const [showLoadAllButtonSpinner, setShowLoadAllButtonSpinner] = useState(false);
  const isBrowser = useIsBrowser();
  const {
    isTabletOrDesktop
  } = useScreen();
  if (!showLoadMoreButton) {
    return null;
  }
  let t1;
  if ($[0] !== loadAllProducts) {
    t1 = () => {
      setShowLoadAllButtonSpinner(true);
      setTimeout(() => {
        loadAllProducts();
      }, 10);
    };
    $[0] = loadAllProducts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const loadAllProductsAndShowSpinner = t1;
  const showLoadAllButton = !hideShowAllButton && isBrowser && isTabletOrDesktop && loadMoreClickCount >= 2;
  const t2 = isTabletOrDesktop ? loadAllProductsAndShowSpinner : null;
  const t3 = showLoadMoreButtonSpinner || !showLoadAllButton && showLoadAllButtonSpinner;
  let t4;
  if ($[2] !== loadMoreClickCount || $[3] !== loadMoreProducts || $[4] !== t2 || $[5] !== t3) {
    t4 = <ProductListingLoadMoreButton clickCount={loadMoreClickCount} onClick={loadMoreProducts} onLongPress={t2} isLoading={t3} />;
    $[2] = loadMoreClickCount;
    $[3] = loadMoreProducts;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== loadAllProductsAndShowSpinner || $[8] !== showLoadAllButton || $[9] !== showLoadAllButtonSpinner) {
    t5 = showLoadAllButton && <div className="flex p-2"><CtaButton color="brand" data-xc="ProductListingShowAllButton" onClick={loadAllProductsAndShowSpinner} isLoading={showLoadAllButtonSpinner} styling="solid-button">Show All</CtaButton></div>;
    $[7] = loadAllProductsAndShowSpinner;
    $[8] = showLoadAllButton;
    $[9] = showLoadAllButtonSpinner;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex justify-center items-center gap-4">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default ProductListingLoadMoreButtons;